import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiFormDataRequest, apiV1Request } from '#shared/api/requests';
import {
    OpenApiGetCashiersMethod,
    OpenApiGetCashiersUrl,
    type OpenApiSchemaCashierType,
    type OpenApiSchemaGetCashierResponse,
    OpenApiSetupAtolIntegrationMethod,
    type OpenApiSetupAtolIntegrationResponseSuccess,
    OpenApiSetupAtolIntegrationUrl,
    OpenApiSwitchCashierMethod,
    OpenApiSwitchCashierUrl,
} from '#shared/api/schema';

const cashiersTag = 'cashiers' as const;

const cashiersApi = createApi({
    name: 'entities/integration/api/cashiersApi',
    baseQuery: createBaseQuery(apiV1Request),
    tagTypes: [cashiersTag],
    endpoints: (builder) => {
        return {
            getCashiers: builder.query<OpenApiSchemaGetCashierResponse, void>({
                query: () => {
                    return {
                        url: OpenApiGetCashiersUrl,
                        method: OpenApiGetCashiersMethod,
                    };
                },
                providesTags: [cashiersTag],
            }),
            setupAtol: builder.mutation<OpenApiSetupAtolIntegrationResponseSuccess, FormData>({
                queryFn: async (formData, api, extraOptions) => {
                    const formDataBaseQuery = createBaseQuery(apiFormDataRequest);
                    const result = await formDataBaseQuery(
                        {
                            url: OpenApiSetupAtolIntegrationUrl,
                            method: OpenApiSetupAtolIntegrationMethod,
                            body: formData,
                        },
                        api,
                        extraOptions
                    );

                    if (result.error) {
                        return { error: result.error };
                    }

                    return { data: result.data as OpenApiSetupAtolIntegrationResponseSuccess };
                },
                invalidatesTags: (_, error) => {
                    if (error) {
                        return [];
                    }

                    return [cashiersTag];
                },
            }),
            setActiveCashier: builder.mutation<void, OpenApiSchemaCashierType>({
                query: (cashierType) => {
                    return {
                        url: OpenApiSwitchCashierUrl,
                        method: OpenApiSwitchCashierMethod,
                        body: { cashier: cashierType },
                    };
                },
                invalidatesTags: (_, error) => {
                    if (error) {
                        return [];
                    }

                    return [cashiersTag];
                },
            }),
        };
    },
});

export const useIntegrationGetCashiers = cashiersApi.useGetCashiersQuery;
export const setupAtolIntegration = cashiersApi.endpoints.setupAtol.mutate;
export const setIntegrationActiveCashier = cashiersApi.endpoints.setActiveCashier.mutate;
